export const FETCH_ALLEYE_PROVIDERS = 'FETCH_ALLEYE_PROVIDERS';
export const RESET_ALLEYE_PROVIDERS = 'RESET_ALLEYE_PROVIDERS';
export const FETCH_ALLEYE_PROVIDERS_SUCCESS = 'FETCH_ALLEYE_PROVIDERS_SUCCESS';
export const FETCH_ALLEYE_PROVIDERS_FAILED = 'FETCH_ALLEYE_PROVIDERS_FAILED';
export const LOADING_ALLEYE_PROVIDERS = 'LOADING_ALLEYE_PROVIDERS';
